import { apiSliceV2 } from "../../apiSlice";

export const locationsApiSlice = apiSliceV2.injectEndpoints({
    tagTypes: ["Location"],
    endpoints: (builder) => ({
        getLocationById: builder.query({
            query: ({ accountId, locationId }) => ({
                url: `/Locations/${locationId}`,
                headers: {
                    'X-Account-Id': accountId,
                }
            }),
            providesTags: ["Location"],
        }),
        postLocation: builder.mutation({
            query: ({ accountId, location }) => ({
                url: `/Locations`,
                method: 'POST',
                body: location,
                headers: {
                    'X-Account-Id': accountId,
                }
            }),
            invalidatesTags: ["Location"],
        }),
    }),
});

export const {
    useGetLocationByIdQuery,
    useLazyGetLocationByIdQuery,
    usePostLocationMutation,
} = locationsApiSlice;